/**
 * HTML Templates
 */
import productList from './templates/pages/product-list.html';
import release from './templates/pages/release.html';
import product from './templates/pages/product.html';

const router = [
    '$routeProvider',
    '$locationProvider',
    '$resourceProvider',
];

const fn = (
    $routeProvider,
    $locationProvider,
    $resourceProvider
) => {
    $routeProvider
        .when('/', {
            controller: 'ProductListCtrl',
            controllerAs: 'ctrl',
            templateUrl: productList,
        })
        .when('/release/:releaseId', {
            controller: 'ReleaseCtrl',
            controllerAs: 'ctrl',
            templateUrl: release,
        })
        .when('/:staticName', {
            controller: 'ProductCtrl',
            controllerAs: 'ctrl',
            templateUrl: product,
        })
        .otherwise({
            redirectTo: '/',
        });

    $locationProvider.html5Mode(true);

    // Set 'update' resource call to use the 'PUT' method.
    $resourceProvider.defaults.actions.update = {
        method: 'PUT',
    };

    // Set timeout for all resource calls to 30 secoonds.
    Object.keys($resourceProvider.defaults.actions).map((key) => {
        $resourceProvider.defaults.actions[key].timeout = 30000;
    });
};

router.push(fn);

export default router;



// WEBPACK FOOTER //
// ./resources/assets/app-releases/router.js